import isPlainObject from 'lodash/isPlainObject';
import { DF_KEYWORD_CUSTOM_FIELD, DF_KEYWORD_CUSTOM_INPUT } from '../constants';
import { requiredArg } from './args';

export const getCustomComponentDefinition = (
  schemaNode = requiredArg('schemaNode'),
  customComponentType = requiredArg('customComponentType')
) => {
  if (
    !(
      customComponentType === DF_KEYWORD_CUSTOM_FIELD ||
      customComponentType === DF_KEYWORD_CUSTOM_INPUT
    )
  )
    throw new Error(
      `customComponentType must be one of '${DF_KEYWORD_CUSTOM_FIELD}' or '${DF_KEYWORD_CUSTOM_INPUT}'`
    );

  const customComponent = schemaNode[customComponentType];

  const { customComponent: customComponentName, ...customComponentProps } =
    isPlainObject(customComponent) ? customComponent : { customComponent };

  if (!customComponentName) return null;

  return { customComponentName, customComponentProps, customComponentType };
};
